module.exports = __webpack_public_path__ + "fdfe29c483dbbe6ba7d3b4c991734826.png";